<app-interfix-and-hypothesis-edit
  [showProgressBar]="showProgressBar"
  [isHypothesis]="true"
  [element]="hypothesis"
  [errorMessageSource]="errorMessageSource"
  (changedElementIdEvent)="getExtraHypothesisById($event)"
  (saveElementEvent)="save($event)"
></app-interfix-and-hypothesis-edit>
